import _ from "lodash";
import React, { useEffect, useState } from "react";
import MembersManager from "../../modules/memberManager";
import MembersChart from "../charts/MembersChart";
import { Rctable } from "../table/RcTable";
import "./Members.css";
import SearchBar from "./search/SearchBar.js";

const Members = () => {
  const [members, setAllMembers] = useState([]);
  const [searchTerm, setSearchTerm] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);
  const [pageInfo, setPageInfo] = useState({});
  const [loading, setLoading] = useState(false);

  const getMembers = async () => {
    setLoading(true);
    const membersResp = await MembersManager.getMembersAdmin({
      page: currentPage,
      filter: searchTerm,
    });
    const membersDateDesc = _.orderBy(
      membersResp.members,
      "user.date_joined",
      "desc"
    );
    setAllMembers(membersDateDesc);
    setCount(membersResp.count);
    setPageInfo(membersResp.page);
    setLoading(false);
  };

  React.useEffect(() => {
    async function fetchData() {
      await getMembers();
      if (currentPage > pageInfo.num_pages) {
        setCurrentPage(pageInfo.num_pages);
      }
    }
    fetchData();
  }, [currentPage, searchTerm]);

  useEffect(() => {
    getMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="main-title">
      <h1>Member Data</h1>
      <MembersChart members={members} />
      <h2>All Members</h2>
      <h3>Total: {count}</h3>
      <SearchBar setSearchTerm={setSearchTerm} searchTerm={searchTerm} />
      <button
        onClick={() => setCurrentPage(1)}
        disabled={loading || currentPage === 1}
      >
        &larr;
      </button>
      <button
        onClick={() => setCurrentPage((prev) => prev - 1)}
        disabled={loading || !pageInfo.has_previous}
      >
        Previous
      </button>
      <button
        onClick={() => setCurrentPage((prev) => prev + 1)}
        disabled={loading || !pageInfo.has_next}
      >
        Next
      </button>
      <button
        onClick={() => setCurrentPage(pageInfo.num_pages)}
        disabled={loading || pageInfo.num_pages === pageInfo.current}
      >
        &rarr;
      </button>
      <p>
        Page: {pageInfo.current} of {pageInfo.num_pages}
      </p>
      <p>
        Viewing: {(pageInfo.current - 1) * 50 + 1}-
        {(pageInfo.current - 1) * 50 + members.length}
      </p>
      <div className="member-cards">
        <Rctable data={members} />
      </div>
    </div>
  );
};

export default Members;
